import Pusher from "pusher-js";
const csrfToken = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute("content");
const userString = localStorage.getItem("user");
let token = "";
if (userString) {
  const user = JSON.parse(userString);
  token = user.token;
}
const pusher = new Pusher("e9c7b0122bbd44854f44", {
  cluster: "ap2",
  forceTLS: true,
  authEndpoint: "http://localhost:8000/broadcasting/auth",
  auth: {
    headers: {
      Authorization: `Bearer ${token}`,
      "X-Requested-With": "XMLHttpRequest",
    },
  },
});
export default pusher;
